import { render, staticRenderFns } from "./MarketingAutomationFormStepsItem.vue?vue&type=template&id=59b8c254&scoped=true"
import script from "./MarketingAutomationFormStepsItem.vue?vue&type=script&lang=js"
export * from "./MarketingAutomationFormStepsItem.vue?vue&type=script&lang=js"
import style0 from "./MarketingAutomationFormStepsItem.vue?vue&type=style&index=0&id=59b8c254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b8c254",
  null
  
)

export default component.exports